import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EmptyListPlaceholder, RecordsTable } from "dyl-components";

import LeadsHeader from "./LeadsHeader";
import LeadsRow from "./LeadsRow";
import { Segment } from "semantic-ui-react";
import { CustomGroupUtils, StringUtils } from "utils";
import customFieldsGroupActions from "actions/custom_fields_group";

const LeadsTabTable = ({ isColumnHidden, onPageChange, routeRoot }) => {
    const [params] = useSearchParams();

    const {
        count,
        leads = [],
        isReadingLeads,
    } = useSelector((state) => state.leads_tab);
    const account_type = useSelector(
        (state) => state.account.account?.account_type || ""
    );

    const displayEmptyListTitle = () => {
        const filter = params.get("filter");
        let title = `No Leads `;
        switch (filter) {
            case "open":
                return (title += "Open");
            case "won":
                return (title += "Won");
            case "lost":
                return (title += "Lost");
            default:
                return (title += `Created Under ${StringUtils.capitalize(
                    account_type
                )} Contact`);
        }
    };

    const queryParamsCondition =
        params.get("pipeline_id") || params.get("start") || params.get("end");
    const shouldRenderTable = count !== 0 || queryParamsCondition;

    const { group } = useSelector(state => ({
        group: state.custom_fields_group.page_standard_group,
    }));

    const groupFields = group?.fields?.data || [];
    const priority_options = CustomGroupUtils.getFieldOptions(groupFields, 'priority');
    const rating_options = CustomGroupUtils.getFieldOptions(groupFields, 'rating');
    const dispatch = useDispatch();
    useEffect(()=>{
        dispatch(customFieldsGroupActions.getPageStandardGroup({ group_name: 'lead' }));

    },[dispatch])
    return shouldRenderTable ? (
        <RecordsTable
            tableBodyClassName="ModulesTabTable"
            isTableLoading={isReadingLeads}
            isSearchResultEmpty={count === 0 && queryParamsCondition}
            isTableEmpty={count === 0 && !queryParamsCondition}
            TableHeader={
                <LeadsHeader
                    isColumnHidden={isColumnHidden}
                    routeRoot={routeRoot}
                />
            }
            TableRows={leads.map((lead) => (
                <LeadsRow
                    key={lead.pipeline_id}
                    lead={lead}
                    priority_options={priority_options}
                    rating_options={rating_options}
                    isColumnHidden={isColumnHidden}
                />
            ))}
            recordsCount={count}
            activePage={params.get("page")}
            onPageChange={onPageChange}
            recordsName="Lead"
            emptySubtitle=" "
            emptyListTitle={displayEmptyListTitle()}
        />
    ) : (
        <React.Fragment>
            {isReadingLeads ? (
                <Segment basic loading />
            ) : (
                <EmptyListPlaceholder
                    title={displayEmptyListTitle()}
                    subtitle={" "}
                />
            )}
        </React.Fragment>
    );
};

export default LeadsTabTable;
